import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { visitorNameAtom, VisitorState, visitorStateAtom } from "../state";
import { setDefaultWaitingRoomFaviconAndTitle } from "../waiting-room/metadata";
import { useTranslate } from "@growtherapy/i18n";

export function useEnterWaitingRoomCallback() {
  const t = useTranslate();
  const setVisitorName = useSetAtom(visitorNameAtom);
  const setVisitorState = useSetAtom(visitorStateAtom);

  return useCallback(
    (visitorName: string) => {
      setVisitorName(visitorName);
      setVisitorState(VisitorState.WAITING);
      setDefaultWaitingRoomFaviconAndTitle(t);
    },
    [t, setVisitorName, setVisitorState],
  );
}
